import React, { useEffect, useRef } from "react";
import Search from "../../assets/search.svg";
import Table from "../../common/Table";
// import SelectComponent from "../../form-components/Select";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Customers as GetCusts,
  get_customers,
  SyncOmniData,
  sync_omni_data
} from "../../actions/admin/Action";
import { toast } from "react-toastify";
import moment from "moment";

const CustomerTable = (props) => {
  const dispatch = useDispatch();
  const customers = useSelector((state) => state?.admin?.customers?.data);
  const customersLoading = useSelector((state) => state?.admin?.customers?.loading);
  const sync = useSelector((state) => state?.admin?.sync_omni_data);
  const inputRef = useRef();
  const history = useHistory();
  useEffect(() => {
    dispatch(
      get_customers({
        email: localStorage.getItem("email"),
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sync && sync?.data?.status) {
      toast.success("Sync Successful.")
      dispatch(
        get_customers({
          email: localStorage.getItem("email"),
        })
      );
      dispatch({
        type: SyncOmniData.RESET,
      });
    }
    // eslint-disable-next-line
  }, [sync]);
  const columns = [
    {
      header: "Name",
      width: 20,
      accessor: "name",
    },
    {
      header: "Mobile",
      width: 15,
      accessor: "phone",
    },
    {
      header: "Email ID",
      width: 20,
      accessor: "email",
    },
    {
      header: "Customer Id",
      width: 20,
      accessor: "sap_id",
    },
    {
      header: "Country Of Origin",
      width: 15,
      accessor: "address",
    },
    {
      header: "Last Login",
      width: 12,
      accessor: "last_login",
      cell: (text) => {
        return text?.last_login ? moment(text?.last_login).format("DD-MM-YYYY, HH:mm") : "-";
      },
    },
    {
      header: "Account Status",
      width: 15,
      accessor: "status",
    },
  ];
  return (
    <div>
      <div className="table-head flex-between">
        <div className="v-center">
          <div className="input">
            <img src={Search} alt="search" />
            <input placeholder={"Search by Name / Email / Mobile"} onChange={(e) => {
              if (inputRef.current) {
                clearTimeout(inputRef.current)
              }
              inputRef.current = setTimeout(() => {
                dispatch({
                  type: GetCusts.CHANGED,
                  filter: true,
                  searchKey: e.target.value
                })
              }, 200)
            }} />
          </div>
          {/* <div className="ml2">
            <SelectComponent options={[]} />
          </div>
          <div className="ml2">
            <SelectComponent options={[]} />
          </div> */}
        </div>
        <div className="v-center">
          {/* <div>
            <button className="export-to-xl">Export to excel</button>
          </div>
          <div>
            <button className="ml2 primary-btn">Collect New KYC</button>
          </div> */}
          <div>
            <button
              className="ml2 primary-btn"
              disabled={sync.loading}
              onClick={() => {
                dispatch(
                  sync_omni_data({
                    email: localStorage.getItem("email"),
                  })
                );
              }}
            >
              {sync.loading ? "Syncing" : "Sync Users"}
            </button>
          </div>
        </div>
      </div>
      <div>
        <Table
          onRowClick={(row) => {
            history.push("/admin/customer-info", {
              customer: row,
            });
          }}
          loading={customersLoading || true}
          columns={columns}
          data={Array.isArray(customers) ? customers?.sort((a, b) => a?.name?.localeCompare(b?.name)) : []}
        />
      </div>
    </div>
  );
};

export default CustomerTable;
